import React from 'react';
import { useSelector } from 'react-redux';
import DayPageShell from './DayPageShell';
import PatternQuizGame from '../PatternQuizGame';
import { s3PublicUrl } from '../../../utils/s3PublicUrl';

export default function Day6({ onStageComplete }) {
  const themeData = useSelector((state) => state.theme.data);
  const stage6 = themeData?.stages_data?.stage_6;
  const questions = stage6?.questions;
  const badgeUrl = s3PublicUrl(stage6?.badge);
  const pointsIconUrl = s3PublicUrl(themeData?.points_icon);
  const correctPoints = themeData?.correct_points ?? 0;
  const dayBonusPoints = themeData?.bonus_points ?? 0;

  const hasValidQuestions =
    Array.isArray(questions) &&
    questions.length > 0 &&
    questions.some(
      (q) =>
        String(q?.question ?? '').trim().length > 0 &&
        String(q?.answer ?? '').trim().length > 0
    );
  const isConfigured = !!stage6 && hasValidQuestions;

  return (
    <DayPageShell dayNumber={6} className="main-day-view--immersive main-day-view--day6">
      {!isConfigured ? (
        <p className="main-day-subtitle">
          Stage is not configured: add question and answer entries in stage_6
          questions in the theme.
        </p>
      ) : (
        <PatternQuizGame
          questions={questions}
          rules={stage6.rules}
          badgeUrl={badgeUrl}
          badgeTitle={String(stage6?.title ?? stage6?.name ?? 'Day 6')}
          questionImage={String(stage6?.question_image ?? '')}
          didYouKnowImage={String(stage6?.did_you_know_image ?? '')}
          questionTextWrapClassName="day-question-panel__text-wrap--day6"
          questionTextClassName="day-question-panel__text__day6"
          correctPoints={correctPoints}
          dayBonusPoints={dayBonusPoints}
          pointsIconUrl={pointsIconUrl}
          badgeFallbackLabel="Day 6"
          onComplete={onStageComplete}
        />
      )}
    </DayPageShell>
  );
}
